// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"61233062","80":"f11d34fc","205":"b96dff52","364":"40793ce4","468":"f500ee02","528":"c8d05447","570":"75ba4c3b","585":"c9e7ad11","664":"5e8f7001","990":"4788a130"}[chunkId] + ".chunk.js";
};